import * as React from 'react';

import {
  BasicContact,
  Country,
  EnhancedAppointment,
} from '@bb/domain/dist/types';
import errorReporter from '@app/errorReporter';
import API from 'api';
import { formatDateStrWithYearAndDay, formatTimeStr } from 'utils';
import { GetAckWrapperResponse } from 'api/get/getCovid19AckWrapper';

export interface COVID19AckTemplateProps {
  appointment: Pick<EnhancedAppointment, 'time' | 'timeEnd' | 'coop'> & {
    listing: Pick<
      EnhancedAppointment['listing'],
      'line1' | 'line2' | 'timezone'
    >;
  };
  ackTemplate: string;
  country: Country;
}

export type CovidAppointmentType = Omit<
  COVID19AckTemplateProps['appointment'],
  'coop'
> &
  Pick<EnhancedAppointment, 'id' | 'covid19Signed' | 'listingId'> & {
    coop?: BasicContact;
  };

const COVID19AckTemplate: React.FC<COVID19AckTemplateProps> = ({
  appointment,
  ackTemplate,
  country,
}) => {
  const [wrapper, setWrapper] = React.useState<GetAckWrapperResponse>({
    header: '',
    footer: '',
  });

  React.useEffect(() => {
    (async () => {
      try {
        let { header, footer } = await API.GET.getCovid19AckWrapper(country);
        const { timezone } = appointment.listing;
        const dateStrWithYear = formatDateStrWithYearAndDay(
          appointment.time,
          timezone,
        );
        const timeStr = formatTimeStr(appointment.time, timezone);
        const timeEndStr = formatTimeStr(appointment.timeEnd, timezone);
        header = header
          .replace(
            '{LISTING ADDRESS}',
            ` ${appointment?.listing.line1} ${
              appointment?.listing.line2 || ''
            }`,
          )
          .replace(
            '{REQUESTED SHOWING DATE / TIME}',
            ` ${dateStrWithYear} / ${timeStr} - ${timeEndStr}`,
          );
        footer = footer
          .replace(
            '{SHOWING BROKERAGE NAME}',
            ` ${appointment.coop?.org?.name}`,
          )
          .replace('{SHOWING AGENT NAME}', ` ${appointment.coop?.name}`)
          .replace('{REQUIRE SIGNATURE}', '');
        setWrapper({ header, footer });
      } catch (err) {
        errorReporter.error(err);
      }
    })();
  }, []);
  return (
    <>
      <div
        style={{ marginTop: '20px' }}
        dangerouslySetInnerHTML={{
          __html: wrapper.header,
        }}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: ackTemplate,
        }}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: wrapper.footer,
        }}
      />
    </>
  );
};

export default COVID19AckTemplate;
